export const STORE_LINKS = {
  apple: "https://apps.apple.com/it/app/e-tanika/id6761620267?uo=4",
  google: "https://play.google.com/store/apps/details?id=com.etanika.app",
};

export const CONTACTS = {
  developer: "ZeroCinqueZero",
  seller: "ZEROCINQUEZERO SRL SEMPLIFICATA",
  website: "http://www.zerocinquezero.it/",
  supportEmail: "info@zerocinquezero.it",
  appStoreSupportEmail: "o.colognesi@zerocinquezero.it",
  privacyPolicy: "https://www.zerocinquezero.com/privacy-policy-e-tanika",
  appStorePrivacyPdf: "https://www.zerocinquezero.it/download/privacy_hybrid_garage.pdf",
};

export const ASSETS = {
  icon: "https://play-lh.googleusercontent.com/o2t-jmBCDbfAXDsurtIdXLqdkrbJopQstXQIeypVBuP2zeU8r8X2CelK3vBcEatw5S_k452goTbZcOOvSt8e=w240-h480-rw",
  appleIcon: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/35/e4/59/35e459fd-85b5-c46e-4dfd-8ae620b3f76e/AppIcon-0-0-1x_U007epad-0-1-85-220.png/512x512bb.jpg",
  premiumScreenshot: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/7by7dxgm_ScreenshotPremium.jpg",
  screenshots: [
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/hq3l4mg7_Screenshot1.png",
      alt: "Screenshot e-Tanika con cruscotto veicolo, consumi, autonomia e azioni rapide",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/oqufxxo3_Screenshot2.png",
      alt: "Screenshot e-Tanika con mappa carburante, prezzi e Eco-Scelta",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/94g59umy_Screenshot3.png",
      alt: "Screenshot e-Tanika con registrazioni veicolo e storico rifornimenti",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/fm4lv8av_Screenshot4.png",
      alt: "Screenshot e-Tanika con inserimento spesa, categorie e salvataggio",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/fpqitt8r_Screenshot5.png",
      alt: "Screenshot e-Tanika con pianificazione viaggio e riepilogo percorso",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/53lmfh57_Screenshot6.png",
      alt: "Screenshot e-Tanika con statistiche, costi carburante mensili e trend consumi",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/29tbinvj_Screenshot7.png",
      alt: "Screenshot e-Tanika con garage, impostazioni e accesso Premium",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/tptj03w4_Screenshot8.png",
      alt: "Screenshot e-Tanika con scansione e nuovo rifornimento Premium",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/1z6rkpjs_Screenshot9.png",
      alt: "Screenshot e-Tanika con configurazione veicolo, colore icona e doppia alimentazione",
    },
    {
      src: "https://customer-assets.emergentagent.com/job_etanika-landing/artifacts/7by7dxgm_ScreenshotPremium.jpg",
      alt: "Screenshot e-Tanika Premium con funzionalità avanzate e acquisto una tantum",
    },
  ],
};

export const NAV_ITEMS = [
  { id: "vantaggi", label: "Vantaggi" },
  { id: "funzionalita", label: "Funzionalità" },
  { id: "screenshot", label: "Screenshot" },
  { id: "privacy", label: "Privacy" },
  { id: "premium", label: "Premium" },
  { id: "faq", label: "FAQ" },
];

export const HERO_BADGES = ["Gratis subito", "Premium una tantum", "Senza account"];

export const BENEFITS = [
  {
    icon: "map",
    title: "Trova dove conviene",
    text: "Visualizza sulla mappa i distributori vicini e confronta i prezzi del carburante selezionato, inclusi benzina, diesel, GPL e metano.",
  },
  {
    icon: "receipt",
    title: "Tutto sotto controllo",
    text: "Registra rifornimenti, ricariche e spese del veicolo in uno storico ordinato per leggere meglio consumi, frequenza e costi reali.",
  },
  {
    icon: "garage",
    title: "Garage multi-mezzo",
    text: "Organizza auto, moto, scooter, furgoni e altri mezzi in un unico spazio digitale, anche con doppia alimentazione.",
  },
  {
    icon: "zap",
    title: "Elettrico e ibrido inclusi",
    text: "Consulta colonnine elettriche con potenza, punti di ricarica e tipologia AC/DC; gestisci anche veicoli ibridi con due alimentazioni.",
  },
  {
    icon: "camera",
    title: "Più rapido con Premium",
    text: "Velocizza l’inserimento tramite foto del display della pompa o della ricevuta e pianifica i viaggi con strumenti avanzati.",
  },
];

export const FEATURES = [
  {
    icon: "fuel",
    title: "Mappa distributori e prezzi",
    text: "Scegli il tipo di carburante e confronta rapidamente i prezzi disponibili nella tua zona per individuare le soluzioni più convenienti.",
    points: ["Benzina", "Diesel", "GPL", "Metano"],
  },
  {
    icon: "battery",
    title: "Colonnine elettriche",
    text: "Visualizza le colonnine nelle vicinanze con informazioni utili come potenza erogata, punti disponibili e tipo di ricarica AC/DC.",
    points: ["Potenza", "Punti ricarica", "AC/DC", "Mappa"],
  },
  {
    icon: "navigation",
    title: "Eco-Scelta",
    text: "Con il pulsante rapido Eco-Scelta puoi avviare la navigazione verso il distributore più conveniente in base al carburante selezionato.",
    points: ["Scelta rapida", "Navigazione", "Prezzo selezionato", "Vicino a te"],
  },
  {
    icon: "car",
    title: "Garage digitale",
    text: "Aggiungi e gestisci più veicoli personali o di lavoro, inclusi mezzi con doppia alimentazione fino a due tipi nello stesso profilo.",
    points: ["Auto", "Moto", "Scooter", "Furgoni"],
  },
  {
    icon: "wallet",
    title: "Spese e storico",
    text: "Annota rifornimenti, chilometri, quantità, prezzo e costi extra come officina, gomme, manutenzione, parcheggi e assicurazione.",
    points: ["Rifornimenti", "Consumi", "Manutenzione", "Costi"],
  },
  {
    icon: "route",
    title: "Viaggi e inserimento foto",
    text: "Le funzionalità Premium includono pianificazione viaggi e inserimento rapido con foto del display della pompa o della ricevuta.",
    points: ["Premium", "Foto", "Pianificazione", "Una tantum"],
  },
];

export const PRIVACY_POINTS = [
  "Non richiede registrazione o creazione di un account.",
  "I dati inseriti sono salvati localmente sul dispositivo.",
  "L’app non raccoglie nessun dato personale.",
  "Nessun dato raccolto e nessun dato condiviso con terze parti.",
  "Solo la scansione foto invia temporaneamente l’immagine ai servizi necessari per il riconoscimento del contenuto.",
];

export const PREMIUM_POINTS = [
  "Viaggi: Pianifica percorsi con stazioni lungo la rotta e stima autonomia dual-fuel.",
  "Eco-Scelta: l’app ti porta al distributore più economico in zona.",
  "Portami qua: ti guida verso il distributore selezionato.",
  "Scansione Smart: compila il rifornimento fotografando il display o la ricevuta.",
  "Importa/Export: esporta e importa i tuoi dati di backup.",
  "Multi-mezzo: gestisci più veicoli contemporaneamente nel garage.",
];

export const FREE_POINTS = [
  "Consultazione mappa distributori e colonnine.",
  "Confronto prezzi per carburante selezionato.",
  "Registrazione rifornimenti, consumi e spese.",
  "Uso immediato dell’app, senza account.",
];

export const AUDIENCES = [
  "Chi usa l’auto ogni giorno",
  "Chi gestisce più veicoli personali o di lavoro",
  "Chi vuole monitorare con precisione spese carburante e costi",
  "Chi guida mezzi benzina, diesel, GPL, metano, ibridi o elettrici",
  "Chi cerca uno strumento pratico per annotare rifornimenti senza perdere tempo",
];

export const FAQ_ITEMS = [
  {
    q: "Serve un account per usare e-Tanika?",
    a: "No, l’app non chiede registrazione o creazione di un account: scaricala e usala subito.",
  },
  {
    q: "Dove vengono salvati i miei dati?",
    a: "I dati che inserisci restano salvati localmente sul tuo dispositivo.",
  },
  {
    q: "La scansione tramite foto invia immagini online?",
    a: "Solo la funzione di scansione foto invia temporaneamente l’immagine ai servizi necessari per riconoscere il contenuto e velocizzare l’inserimento.",
  },
  {
    q: "Premium è un abbonamento?",
    a: "No. Le funzionalità Premium si sbloccano con pagamento una tantum, senza abbonamenti.",
  },
  {
    q: "Che veicoli posso gestire?",
    a: "Puoi gestire più mezzi: auto, moto, scooter, furgoni e altri veicoli, compresi veicoli ibridi con doppia alimentazione.",
  },
  {
    q: "e-Tanika mostra anche le colonnine elettriche?",
    a: "Sì. Trovi la mappa delle colonnine con potenza erogata, punti di ricarica disponibili e tipo di ricarica AC/DC.",
  },
  {
    q: "Su iPhone quale versione iOS serve?",
    a: "Per usare e-Tanika su iPhone serve iOS 15.1 o versioni successive.",
  },
];
